export default __webpack_public_path__ + "static/media/RohitBarve.6018c671.png";